import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
import { useGetUsers } from './useGetUsers/useGetUsers';
export const projectCreatorFilterLabel = () => t({ message: 'Created by', comment: 'Insights filter: Created by' });
export const ProjectCreatorFilter = withFilterErrorBoundary(() => {
    const { data, error, loading } = useGetUsers();
    const disabled = Boolean(loading || error);
    return (<SearchStringFilter name="createdByUserId" items={data} label={projectCreatorFilterLabel()} loading={disabled}/>);
});
